const topicItems = [
  { name: '热门影视', icon: 'ri-movie-2-line', count: '2.3k 讨论', active: true },
  { name: '短视频创作', icon: 'ri-vidicon-line', count: '1.8k 讨论', active: true },
  { name: '综艺节目', icon: 'ri-tv-2-line', count: '1.5k 讨论', active: false },
  { name: '日韩剧集', icon: 'ri-flower-line', count: '1.2k 讨论', active: true },
  { name: '纪录片', icon: 'ri-earth-line', count: '980 讨论', active: false },
  { name: '动画动漫', icon: 'ri-ghost-line', count: '2.1k 讨论', active: true },
  { name: '直播互动', icon: 'ri-live-line', count: '890 讨论', active: false },
  { name: '音乐MV', icon: 'ri-music-2-line', count: '760 讨论', active: false },
  { name: '游戏视频', icon: 'ri-gamepad-line', count: '1.9k 讨论', active: true },
  { name: '美食探店', icon: 'ri-restaurant-line', count: '650 讨论', active: false },
  { name: '旅行Vlog', icon: 'ri-map-pin-line', count: '540 讨论', active: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门话题</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            当前视频平台用户最关注的话题方向与讨论热度
          </p>
        </div>
        <div className="flex flex-wrap gap-3 justify-center">
          {topicItems.map((item, i) => (
            <div
              key={i}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer whitespace-nowrap ${
                item.active
                  ? 'bg-primary-100/70 border-primary-200 text-primary-700 hover:bg-primary-200/70'
                  : 'bg-background-50 border-background-200/70 text-foreground-600 hover:border-accent-200 hover:text-accent-700'
              }`}
            >
              <span className={`w-5 h-5 flex items-center justify-center`}>
                <i className={`${item.icon} text-sm`}></i>
              </span>
              <span className="text-sm font-medium">{item.name}</span>
              <span className="text-xs opacity-60">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}